import { useCallback, useEffect } from 'react'
import { useWebSocketStore } from '@/store/websocket'
import type { EventMessage } from '@/types'

export function useWebSocket() {
  const { connect, disconnect, subscribe, unsubscribe } = useWebSocketStore()

  return {
    connect,
    disconnect,
    subscribe,
    unsubscribe,
  }
}

export function useWebSocketSubscription(
  channels: string[],
  callback?: (message: EventMessage) => void
) {
  const { messages, subscribe, unsubscribe } = useWebSocketStore()

  useEffect(() => {
    // Subscribe to channels
    subscribe(channels)

    return () => {
      // Unsubscribe when component unmounts
      unsubscribe(channels)
    }
  }, [channels.join(',')]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!callback) return

    // Process new messages
    const latestMessage = messages[messages.length - 1]
    if (latestMessage && channels.includes(latestMessage.channel)) {
      callback(latestMessage)
    }
  }, [messages.length]) // eslint-disable-line react-hooks/exhaustive-deps
}